import React from "react";

const CircleTickIcon = (props) => {
    return(
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"><path d="M9.61 0a9 9 0 1 0 9 9 9 9 0 0 0-9-9zm5.133 7.51l-5.41 5.681a1.586 1.586 0 0 1-1.142.492h-.007a1.586 1.586 0 0 1-1.139-.483l-2.871-2.956a1.587 1.587 0 1 1 2.278-2.21l1.72 1.773 4.271-4.485a1.587 1.587 0 0 1 2.3 2.189z" transform="translate(-.61)" fill={props.fill}/></svg>
    )
}

export default CircleTickIcon;
